import React, { Component } from 'react';

export class Contact extends Component {
    render() {
        return (
            <div data-form-id='801ddbda-40e6-f011-8544-7c1e5236b083' data-form-api-url='https://public-eur.mkt.dynamics.com/api/v1.0/orgs/09cc6ce8-e812-41e5-a03e-61c58ebb8054/landingpageforms' data-cached-form-url='https://assets-eur.mkt.dynamics.com/09cc6ce8-e812-41e5-a03e-61c58ebb8054/digitalassets/forms/801ddbda-40e6-f011-8544-7c1e5236b083'>
                &nbsp;
            </div>
        );
    }
}
